<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-dialog width="1000px" v-model="showDialog" scrollable>
        <v-card>
            <v-toolbar class="kbLightBlue" dark text flat>
                <div class="text-h6">{{$t('general.detailedConsumption')}}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleDialog(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="py-4">
                <v-data-table :must-sort="false"
                              :headers="headers"
                              :items="usage"
                              class="elevation-2"
                              :loading="loadingUsage"
                              :options.sync="options"
                              :footer-props="footerProps"
                              :server-items-length="totalUsage">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon color="primary"
                                                v-on="on">
                                            {{ getIconType(item.chargeType) }}
                                        </v-icon>
                                    </template>
                                    <span v-if="item['payments__charge_type.info'] !== null" style="text-transform: capitalize">{{ item['payments__charge_type.info'] }}</span>
                                    <span v-else style="text-transform: capitalize">{{ item.description }}</span>
                                </v-tooltip>
                            </td>
                            <td>{{ item['payments__charge_type.label'] ? item['payments__charge_type.label'] : item.description }}</td>
                            <td>{{ item.quantity }}</td>
                            <td>{{ item.amount }}</td>
                            <td>{{item.date | nullToDateNow | moment('DD/MM/YYYY')}}</td>
                        </tr>
                    </template>

                    <template v-slot:no-data>
                        <v-row>
                            <v-col class="text-center" cols="12" v-if="loadingUsage">{{$t('general.loadingRecords')}}</v-col>
                            <v-col cols="12" class="red--text text-center" v-else>{{$t('general.noMovementsRecords')}}</v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" outlined @click="toggleDialog(false)">{{$t('general.close')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import messageTypes from '@/libs/messageTypes'
export default {
  computed: {
    ...mapState({
      usage: state => state.payments.detailedUsage,
      totalUsage: state => state.payments.totalDetailedUsage,
      loadingUsage: state => state.payments.loadingDetailedUsage,
      searchDetailedUsage: state => state.payments.searchDetailedUsage
    }),
    showDialog: {
      get () {
        return this.$store.state.payments.showDialogTransactionDetails
      },
      set (value) {
        this.toggleDialog(value)
      }
    },
    headers () {
      return [
        { text: '', align: 'left', value: 'chargeType' },
        { text: this.$t('general.service'), align: 'left', value: 'description' },
        { text: this.$t('general.amount'), align: 'left', value: 'quantity' },
        { text: this.$t('general.value'), align: 'left', value: 'amount' },
        { text: this.$t('general.date'), value: 'date' }
      ]
    },
    footerProps () {
      return {
        'items-per-page-text': this.$t('general.recordsPerPage'),
        'items-per-page-options': [50, 100, 200]
      }
    }
  },
  data () {
    return {
      options: {},
      getIconType: messageTypes.getIconType
    }
  },
  methods: {
    getUsage () {
      this.$store.commit('SET_PAGINATION_DETAILED_USAGE', {
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        sortBy: this.options.sortBy ? this.options.sortBy[0] : '',
        descending: this.options.sortDesc ? this.options.sortDesc[0] : ''
      })
      this.$store.dispatch('getDetailedUsage')
    },
    toggleDialog (value) {
      this.$store.commit('TOGGLE_DETAILED_USAGE_DIALOG', value)
    }
  },
  watch: {
    searchDetailedUsage (value) {
      this.getUsage()
    },
    options: {
      handler () {
        this.getUsage()
        this.$vuetify.goTo(0)
      },
      deep: true
    }
  }
}
</script>
